<div class="page-container container-fluid p-3">
  <div>
    <ng-container *ngIf="showImpersonateText">
      <div class="p-2" fxLayout="row" fxLayoutAlign="start center">
        Currently impersonating Broker Name:&#x00A0; {{dataService.impersonateRowData.brokerName}} <button mat-button color="primary" class="ml-2" (click)="reset()">Reset</button>
      </div>
    </ng-container>
    <ng-container *ngIf="headerForm">
    <div class="row mb-3 pt-1" [formGroup]="headerForm">
      <div class="col-sm-12  col-md-6 col-lg-3">
        <mat-select class="filterDropdown" placeholder="Select Filter Type" formControlName="dropDownSelection" (selectionChange)="dropDownSelectionChange()">
          <ng-container *ngFor="let option of dropDownOptions">
            <mat-option [value]="option.value">
              {{option.label}}
            </mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4" fxLayout="row">
        <input class="form-control" [readOnly]="!dropDownSelection" mdbInput type="text" formControlName="searchValue" [placeholder]="getDropdownLabel()"/>
      </div>
      <button mat-flat-button color="primary" class="search-btn ml-2" [disabled]="(!dropDownSelection || !searchValue) || (dropDownSelection !== 'id' && searchValue.length <= 4)" (click)="getImpersonateData()">Search</button>
    </div>
    </ng-container>
    <div style="background-color: whitesmoke">
      <div style="background-color: #54B4D3;color: white" class="p-2" fxLayout="row"
           fxLayoutAlign="space-between center">
        <h2 class="m-0">Broker Selection</h2>
      </div>
      <app-data-table class="data-table" #adminTable [stickyHeader]="true" (onRowDoubleClicked)="rowClicked($event)" [loading]="loading" [rows]="dataSource" [columnDefs]="displayedColumns"></app-data-table>
    </div>
  </div>
</div>

